// ============================================================
// PERGUNTAS FREQUENTES — accordion: um cartão aberto por vez
// Abrir um fecha o que estava aberto. Clicar no aberto fecha
// ele mesmo e a lista fica toda recolhida.
// Mantém aria-expanded e o atributo hidden em dia, pra leitor
// de tela e teclado acompanharem.
// ============================================================

(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }

    function iniciar() {
        var cartoes = Array.prototype.slice.call(document.querySelectorAll('[data-faq]'));
        if (!cartoes.length) return;

        cartoes.forEach(function (cartao) {
            var botao    = cartao.querySelector('[data-faq-toggle]');
            var resposta = cartao.querySelector('[data-faq-answer]');
            if (!botao || !resposta) return;

            botao.addEventListener('click', function () {
                var abrindo = !cartao.classList.contains('is-open');

                // Fecha todos antes — inclusive este, pro caso de clique no aberto.
                cartoes.forEach(function (outro) { aplicar(outro, false); });

                if (abrindo) aplicar(cartao, true);
            });
        });
    }

    // Sem o segundo argumento, fecha.
    function aplicar(cartao, aberto) {
        var botao    = cartao.querySelector('[data-faq-toggle]');
        var resposta = cartao.querySelector('[data-faq-answer]');
        if (!botao || !resposta) return;

        cartao.classList.toggle('is-open', !!aberto);
        botao.setAttribute('aria-expanded', aberto ? 'true' : 'false');
        resposta.hidden = !aberto;
    }
})();
